import React from 'react';
import { CardHeader, CardText, Card, FontIcon } from 'material-ui';
import pluralize from 'pluralize';
import R from 'ramda';
import SingleLocList from './single-loc';
import GroupByNameIcon from 'material-ui/svg-icons/content/font-download';
const propTypes = {
  templateName: React.PropTypes.string,
  docs: React.PropTypes.array,
  onExpandChange: React.PropTypes.func,
  expanded: React.PropTypes.bool,
  templateLength: React.PropTypes.number,
  draftLength: React.PropTypes.number,
  actions: React.PropTypes.object,
};

const TemplateNameGroup = ({ templateName, docs, onExpandChange, expanded, actions }) => {
  if (R.isEmpty(docs)) return <div/>;
  return (<Card onExpandChange={onExpandChange} expanded={expanded} style={{ boxShadow: 'none', borderBottom: '1px solid #e0e0e0' }}>
    <CardHeader
      title={<div style={{ color: 'rgba(0, 0, 0, 0.64)' }} className="flex-center">
        <GroupByNameIcon color="rgba(0, 0, 0, 0.64)"/> &nbsp;
        {templateName}
      </div>}
      subtitle={<div style={{ paddingLeft: '30px' }}>
        {docs.length} {pluralize('template', docs.length)}
      </div>}
      style={{ padding: '8px 16px' }}
      actAsExpander
      showExpandableButton
    />
    <CardText
      style={{ paddingTop: '0px' }}
      expandable
    >
      <SingleLocList
        docs={docs}
        showLocName
        {...actions}
      />
    </CardText>
  </Card>);
};
TemplateNameGroup.propTypes = propTypes;
export default TemplateNameGroup;



// WEBPACK FOOTER //
// ./src/app/components/contracting/template-list/list/NameGroup.jsx